import moment from 'moment';
import 'moment-timezone';

export function formatDateTimePerLocale(dateTime: any, locale: any) {
    moment.locale(locale);
    const datetimeConverted = moment.tz(dateTime, 'America/New_York');
    const convertedUTC = datetimeConverted.utc();
    return moment(convertedUTC).local().format('L LTS');
}
